import { Splide, Video } from "../main.js";

// Slide hero element
const splideHeroEl = document.querySelectorAll(".js-splide-hero");

// Breakpoint detection
const handleBreakpointChange = (e) => {
  return e.matches;
};

const mediaQuery = window.matchMedia("(min-width: 768px)");

// Functions add video responsive src
const videoResponsiveUpdate = (videoSlide) => {
  if (handleBreakpointChange(mediaQuery) && videoSlide.dataset.videoDesktop) {
    videoSlide.setAttribute(
      "data-splide-html-video",
      videoSlide.dataset.videoDesktop,
    );
  }

  if (!handleBreakpointChange(mediaQuery) && videoSlide.dataset.videoMob) {
    videoSlide.setAttribute(
      "data-splide-html-video",
      videoSlide.dataset.videoMob,
    );
  }
};

if (splideHeroEl.length > 0) {
  Array.from(splideHeroEl).forEach((heroSlider) => {
    const splideHeroLength =
      heroSlider.querySelectorAll(".splide__slide").length;

    heroSlider.querySelectorAll(".splide__slide").forEach((slide) => {
      if (slide.dataset.videoDesktop || slide.dataset.videoMob) {
        videoResponsiveUpdate(slide);
      }
    });

    // Settings
    const splideHero = new Splide(heroSlider, {
      arrows: false,
      perPage: 1,
      drag: splideHeroLength > 1 ? true : false,
      cover: true,
      pagination: splideHeroLength > 1 ? true : false,
      video: {
        hideControls: true,
        loop: true,
        muted: true,
        disableOverlayUI: true,
        autoplay: true,
        volume: 0,
        playerOptions: {
          htmlVideo: {
            preload: "auto",
            playsInline: true,
            muted: true,
            autoplay: false,
            currentTime: 0,
          },
        },
      },
    });

    // Events
    splideHero.on("ready", (e) => {
      if (
        splideHero.Components.Slides.getAt(splideHero.index).slide.dataset
          .splideHtmlVideo
      ) {
        setTimeout(() => {
          splideHero.Components.Slides.getAt(splideHero.index)
            .slide.querySelector("video")
            .setAttribute("autoplay", "");

          splideHero.Components.Slides.getAt(splideHero.index)
            .slide.querySelector("video")
            .play();
        }, 500);
      }
    });

    splideHero.on("moved", (e) => {
      if (
        splideHero.Components.Slides.getAt(splideHero.index).slide.dataset
          .splideHtmlVideo
      ) {
        setTimeout(() => {
          splideHero.Components.Slides.getAt(splideHero.index)
            .slide.querySelector("video")
            .setAttribute("autoplay", "");

          splideHero.Components.Slides.getAt(splideHero.index)
            .slide.querySelector("video")
            .play();
        }, 500);
      }
    });

    // Init
    splideHero.mount({ Video });
  });
}
